import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar() 
{
  return (
    <div className="bg-light border p-3 h-100">
	{/*<h5 className="mb-3">Menu</h5>*/}
      <ul className="list-unstyled">
		
        <li className="mb-2">
          <Link to="/">Home</Link>
        </li>
		
        <li className="mb-2">
          <Link to="/login">Login</Link>
        </li>

		<li className="nav-item">
		  <Link className="nav-link" to="/employee/new">
			Employee Registration
		  </Link>
		</li>
      </ul>
    </div>
  );
}